<div class="wep-carousel-item__content" cdkTrapFocus [@animate]="animationState">
    <ng-content></ng-content>
</div>